// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DatabaseSelectQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
}>;

export type DatabaseSelectQuery = {
  __typename?: "GraphqlQuery";
  getDatabases: Array<{
    __typename?: "Database";
    id: string;
    hidden: boolean;
    datname?: string | null;
  }>;
};

export const DatabaseSelectDocument = gql`
  query DatabaseSelect($serverId: ID!) {
    getDatabases(serverId: $serverId) {
      id
      hidden
      datname
    }
  }
`;

/**
 * __useDatabaseSelectQuery__
 *
 * To run a query within a React component, call `useDatabaseSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatabaseSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatabaseSelectQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *   },
 * });
 */
export function useDatabaseSelectQuery(
  baseOptions: Apollo.QueryHookOptions<
    DatabaseSelectQuery,
    DatabaseSelectQueryVariables
  > &
    (
      | { variables: DatabaseSelectQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DatabaseSelectQuery, DatabaseSelectQueryVariables>(
    DatabaseSelectDocument,
    options,
  );
}
export function useDatabaseSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DatabaseSelectQuery,
    DatabaseSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DatabaseSelectQuery, DatabaseSelectQueryVariables>(
    DatabaseSelectDocument,
    options,
  );
}
// @ts-ignore
export function useDatabaseSelectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DatabaseSelectQuery,
    DatabaseSelectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DatabaseSelectQuery,
  DatabaseSelectQueryVariables
>;
export function useDatabaseSelectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DatabaseSelectQuery,
        DatabaseSelectQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DatabaseSelectQuery | undefined,
  DatabaseSelectQueryVariables
>;
export function useDatabaseSelectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DatabaseSelectQuery,
        DatabaseSelectQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DatabaseSelectQuery,
    DatabaseSelectQueryVariables
  >(DatabaseSelectDocument, options);
}
export type DatabaseSelectQueryHookResult = ReturnType<
  typeof useDatabaseSelectQuery
>;
export type DatabaseSelectLazyQueryHookResult = ReturnType<
  typeof useDatabaseSelectLazyQuery
>;
export type DatabaseSelectSuspenseQueryHookResult = ReturnType<
  typeof useDatabaseSelectSuspenseQuery
>;
export type DatabaseSelectQueryResult = Apollo.QueryResult<
  DatabaseSelectQuery,
  DatabaseSelectQueryVariables
>;
